import React, { useEffect } from 'react';
import Barcode from 'react-barcode';
import { QRCodeCanvas } from 'qrcode.react'; // Import QRCodeCanvas

const Receipt = ({ bookingDetails }) => {
  const {email, name, phoneNumber, bookingId, bookingDate, timeSlot, amountPaid, barcodeImageUrl,numberofPlayers } = bookingDetails;

  useEffect(() => {
    console.log(bookingId)
  }, [bookingId])
  

  return (
    <div className="max-w-4xl mx-auto bg-white p-6 rounded-lg shadow-lg">
      <header className="text-center mb-8">
        <h1 className="text-3xl font-bold text-green-600">Payment Successful</h1>
        <p className="text-xl text-gray-600">Thank you for your booking with Smarthive Pay!</p>
      </header>

      <section className="mb-8">
        <h2 className="text-2xl font-semibold text-gray-800">Booking Details:</h2>
        <p className="text-lg text-gray-700"><strong>Email:</strong> {bookingId}</p>
        <p className="text-lg text-gray-700"><strong>Name:</strong> {bookingId}</p>
        <p className="text-lg text-gray-700"><strong>Phone Number:</strong> {bookingId}</p>

        <p className="text-lg text-gray-700"><strong>Booking ID:</strong> {bookingId}</p>
        <p className="text-lg text-gray-700"><strong>Booking Date:</strong> {bookingDate}</p>
        <p className="text-lg text-gray-700"><strong>Time Slot:</strong> {timeSlot}</p>
        <p className="text-lg text-gray-700"><strong>Number of Players:</strong> {numberofPlayers}</p>
        <p className="text-lg text-gray-700"><strong>Total Amount Paid:</strong> ₦{amountPaid}</p>
      </section>

      <section className="mb-8">
        <h2 className="text-2xl font-semibold text-gray-800">Your Ticket Barcode:</h2>
        <div className="text-center mt-4">
          {/* Display the barcode image */}
          {/* <img src={barcodeImageUrl} alt="Ticket Barcode" className="mx-auto" /> */}
          {/* <Barcode value={bookingId} format="CODE128" width={2} height={100} displayValue={false} /> */}
          {/* <QRCodeCanvas value={bookingId.toString()} size={256} /> */}
          {/* <QRCodeCanvas value={`https://adrenalinehub-v1.onrender.com/redeem/${bookingId.toString()}`} size={256} /> */}
          <QRCodeCanvas value={`https://adrenalinehub-v1.onrender.com/redeem/${bookingId.toString()}`} size={256} />

        </div>
      </section>

      <footer className="text-center mt-8">
        <p className="text-lg text-gray-600">If you have any questions, please contact our support team.</p>
        <p className="text-lg text-gray-600">
          Contact: <a href="mailto:support@smarthivetechsolution.com" className="text-green-600 hover:underline">support@smarthivetechsolution.com</a>
        </p>
      </footer>
    </div>
  );
};

export default Receipt;
